import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mprd-mobile-number-errors',
  templateUrl: 'mobile-number-errors.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileNumberErrorsComponent {
  // FIXME: Set a proper type for this
  @Input() errors: any;
}
